export default __webpack_public_path__ + "static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4";